import axiosRequest from "./axios.config";

export const sendInvitation = async (pageId, payload) =>
  await axiosRequest.post(`/v1/invitations/${pageId}`, payload);
